import { render, staticRenderFns } from "./form17.vue?vue&type=template&id=bde09856&scoped=true&"
import script from "./form17.vue?vue&type=script&lang=js&"
export * from "./form17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde09856",
  null
  
)

export default component.exports